<mat-form-field appearance="outline">
    <mat-label>{{ labelKey | translate }}</mat-label>

    <mat-select [formControl]="control" multiple panelClass="responsibilities-panel"
        [compareWith]="compareResponsibilities">

        <mat-select-trigger>
            <mat-chip-set class="responsibilities-chip" cdkDropList cdkDropListOrientation="mixed"
                (cdkDropListDropped)="drop($event)">

                @for (item of (control.value ?? []); track item) {
                @let canRemove = canRemoveResponsibility(item);

                <mat-chip class="responsibilities-box" cdkDrag (removed)="onResponsibilityRemoved(item)"
                    [removable]="canRemove" [matTooltip]="item.Name | translate" [matTooltipDisabled]="!canRemove">

                    {{ item.Name | translate }}

                    <mat-icon matChipRemove [class.chip-remove-disabled]="!canRemove" [attr.aria-disabled]="!canRemove"
                        [matTooltip]="(tooltipKeyBaseLockedByDependents | translate)" [matTooltipDisabled]="canRemove"
                        matTooltipPosition="above">
                        cancel
                    </mat-icon>
                </mat-chip>
                }
            </mat-chip-set>
        </mat-select-trigger>

        <mat-form-field style="position: sticky; top: -10px; z-index: 1">
            <input matInput placeholder="{{ searchPlaceholderKey | translate }}"
                (keyup)="onFiltered($event.target.value)" />
        </mat-form-field>

        @for (responsibility of filteredResponsibilities$ | async; track responsibility) {
        @let reasonKey = getDisabledReasonKey(responsibility);

        <mat-option [value]="responsibility" (onSelectionChange)="onOptionToggled($event, responsibility, reasonKey)"
            [class.option-disabled-look]="!!reasonKey" [attr.aria-disabled]="!!reasonKey"
            [matTooltip]="reasonKey ? (reasonKey | translate) : ''" [matTooltipDisabled]="!reasonKey"
            matTooltipPosition="right">
            {{ responsibility.Name | translate }}
        </mat-option>
        }
    </mat-select>

    @if (control.invalid && control.touched) {
    <mat-error>{{ invalidFieldKey | translate }}</mat-error>
    }
</mat-form-field>